import { IsAlphanumeric, IsBoolean, IsDate, IsNumber, IsNumberString, IsOptional, IsString } from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantBusinessEntityBankDto } from './merchantBusinessEntityBank.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { CityDto } from './city.dto';
import { CountryDto } from './country.dto';
import { SurfboardMerchantOnboardingDto } from './surfboard-merchant-onboarding';
import { CustomerBusinessType } from '../enum/piecloud-signup';

export class BusinessEntityDto extends BaseDto {
  id: number;
  merchantGroup: MerchantGroupDto;
  businessEntityBank?: MerchantBusinessEntityBankDto[];

  @IsNumber()
  merchantGroupId: number;

  @IsString()
  name: string;

  @IsString()
  registeredOffice: string;

  registeredOfficeLine2?: string;
  registeredOfficeCityId?: number;
  registeredOfficeCity?: CityDto;
  registeredOfficeCountryId?: number;
  registeredOfficeCountry?: CountryDto;
  registeredOfficePostCode?: string;

  @IsNumberString()
  businessNumber: string;

  @IsAlphanumeric()
  vatNumber?: string;

  @IsDate()
  @IsOptional()
  createdDate?: Date;

  @IsDate()
  @IsOptional()
  modifiedDate?: Date;

  @IsNumber()
  @IsOptional()
  version?: number;

  @IsString()
  firstDirector: string;

  @IsString()
  firstDirectorAddress: string;

  @IsBoolean()
  firstDirectorKYC: boolean;

  @IsString()
  secondDirector: string;

  @IsString()
  secondDirectorAddress: string;

  @IsBoolean()
  secondDirectorKYC: boolean;

  @IsString()
  contactOperationalName?: string;

  @IsString()
  contactOperationalPhoneNumber?: string;

  contactOperationalPhoneCountryId?: number;
  contactOperationalPhoneCountry?: CountryDto;

  @IsString()
  contactOperationalEmail?: string;

  @IsString()
  contactFinancialName?: string;

  @IsString()
  contactFinancialPhoneNumber?: string;

  contactFinancialPhoneCountryId?: number;
  contactFinancialPhoneCountry?: CountryDto;

  @IsString()
  contactFinancialEmail?: string;

  @IsString()
  contactMarketingName?: string;

  @IsString()
  contactMarketingPhoneNumber?: string;

  contactMarketingPhoneCountryId?: number;
  contactMarketingPhoneCountry?: CountryDto;

  @IsString()
  contactMarketingEmail?: string;

  @IsString()
  stripeConnectAccountId?: string;

  @IsBoolean()
  stripeConnectAccountEnable?: boolean;

  @IsNumber()
  stripeConnectFeePercentage?: number;

  @IsNumber()
  fireIcan?: number;

  @IsNumber()
  fireBalance?: number;

  @IsOptional()
  @IsBoolean()
  receivesBillingEmails?: boolean;

  surfboardMerchantId: string;
  surfboardMerchantOnboarding?: SurfboardMerchantOnboardingDto;

  businessType: CustomerBusinessType;
}
